import { render } from "./EquipmentAlert.vue?vue&type=template&id=6134ca3c&ts=true"
import script from "./EquipmentAlert.vue?vue&type=script&lang=ts"
export * from "./EquipmentAlert.vue?vue&type=script&lang=ts"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__